import { render, staticRenderFns } from "./SimplePagination.vue?vue&type=template&id=24d9235a"
import script from "./SimplePagination.vue?vue&type=script&lang=js"
export * from "./SimplePagination.vue?vue&type=script&lang=js"
import style0 from "./SimplePagination.vue?vue&type=style&index=0&id=24d9235a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports